import { AppConsts } from '@shared/AppConsts';
import { Component, Injector, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AccountGroupsServiceProxy, AccountGroupDto } from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';
import { TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';
import { CreateOrEditAccountGroupModalComponent } from './create-or-edit-accountGroup-modal.component';

import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Table, TableModule } from 'primeng/table';
import { Paginator, PaginatorModule } from 'primeng/paginator';
import { LazyLoadEvent, PrimeTemplate } from 'primeng/api';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { filter as _filter } from 'lodash-es';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { ExcelColumnSelectionModalComponent } from '@app/shared/common/excel-column-selection/excel-column-selection-modal';

@Component({
    templateUrl: './accountGroups.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
    standalone: false,
})
export class AccountGroupsComponent extends AppComponentBase {
    @ViewChild('createOrEditAccountGroupModal', { static: true })
    createOrEditAccountGroupModal: CreateOrEditAccountGroupModalComponent;

    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    @ViewChild('excelColumnSelectionModal', { static: true })
    excelColumnSelectionModal: ExcelColumnSelectionModalComponent;

    advancedFiltersAreShown = false;
    filterText = '';

    constructor(
        injector: Injector,
        private _accountGroupsServiceProxy: AccountGroupsServiceProxy,
        private _notifyService: NotifyService,
        private _tokenAuth: TokenAuthServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _fileDownloadService: FileDownloadService,

        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    getAccountGroups(event?: LazyLoadEvent) {
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            if (this.primengTableHelper.records && this.primengTableHelper.records.length > 0) {
                return;
            }
        }

        this.primengTableHelper.showLoadingIndicator();

        this._accountGroupsServiceProxy
            .getAll(
                this.filterText,
                this.primengTableHelper.getSorting(this.dataTable),
                this.primengTableHelper.getSkipCount(this.paginator, event),
                this.primengTableHelper.getMaxResultCount(this.paginator, event),
            )
            .subscribe((result) => {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
                this.primengTableHelper.records = result.items;
                this.primengTableHelper.hideLoadingIndicator();
            });
    }

    reloadPage(): void {
        this.paginator.changePage(this.paginator.getPage());
    }

    createAccountGroup(): void {
        this.createOrEditAccountGroupModal.show();
    }

    deleteAccountGroup(accountGroup: AccountGroupDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this._accountGroupsServiceProxy.delete(accountGroup.id).subscribe(() => {
                    this.reloadPage();
                    this.notify.success(this.l('SuccessfullyDeleted'));
                });
            }
        });
    }

    exportToExcel($event): void {
        this._accountGroupsServiceProxy.getAccountGroupsToExcel(this.filterText, $event).subscribe((result) => {
            this._fileDownloadService.downloadTempFile(result);
        });
    }

    resetFilters(): void {
        this.filterText = '';

        this.getAccountGroups();
    }

    showExcelColumnSelectionModal() {
        this._accountGroupsServiceProxy.getAccountGroupExcelColumnsToExcel().subscribe((result) => {
            this.excelColumnSelectionModal.show(result);
        });
    }
}
